// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_DashboardBox_wrapper__24rwb","title":"_DashboardBox_title__AYI_J","titleText":"_DashboardBox_titleText__32UwU"};